import { render, staticRenderFns } from "./industryActivitySummary.vue?vue&type=template&id=1fb8035c&scoped=true"
import script from "./industryActivitySummary.vue?vue&type=script&lang=js"
export * from "./industryActivitySummary.vue?vue&type=script&lang=js"
import style0 from "./industryActivitySummary.vue?vue&type=style&index=0&id=1fb8035c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb8035c",
  null
  
)

export default component.exports